/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerOperatorDto } from '../models/EntityModelResponseContainerOperatorDto';
import type { OperatorDto } from '../models/OperatorDto';
import type { PagedModelEntityModelOperatorDto } from '../models/PagedModelEntityModelOperatorDto';
import type { PagedResourcesAssemblerOperatorDto } from '../models/PagedResourcesAssemblerOperatorDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OperatorControllerService {
    /**
     * @returns PagedModelEntityModelOperatorDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        name,
        page,
        size = 2147483647,
        sort,
    }: {
        assembler: PagedResourcesAssemblerOperatorDto,
        name?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelOperatorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/operators',
            query: {
                'name': name,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerOperatorDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: OperatorDto,
    }): CancelablePromise<EntityModelResponseContainerOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/operators',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        operatorId,
    }: {
        operatorId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/operators/{operatorId}',
            path: {
                'operatorId': operatorId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerOperatorDto OK
     * @throws ApiError
     */
    public static read({
        operatorId,
    }: {
        operatorId: number,
    }): CancelablePromise<EntityModelResponseContainerOperatorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/operators/{operatorId}',
            path: {
                'operatorId': operatorId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerOperatorDto OK
     * @throws ApiError
     */
    public static update({
        operatorId,
        requestBody,
    }: {
        operatorId: number,
        requestBody: OperatorDto,
    }): CancelablePromise<EntityModelResponseContainerOperatorDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/operators/{operatorId}',
            path: {
                'operatorId': operatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
